import React, { useState } from 'react';
import { useInventory } from '../context/InventoryContext';
import { Edit2, Save } from 'lucide-react';

export default function Layout({ children, activeTab, setActiveTab }) {
  const { systemName, setSystemName } = useInventory();
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [tempTitle, setTempTitle] = useState(systemName);

  const saveTitle = () => { setSystemName(tempTitle); setIsEditingTitle(false); };

  const tabs = [
    { id: 'dashboard', label: 'لوحة القيادة' },
    { id: 'transactions', label: 'السندات والحركات' },
    { id: 'products', label: 'دليل الأصناف' },
    { id: 'warehouses', label: 'المستودعات' }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-slate-800 text-white shadow-lg">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <span className="bg-blue-600 p-2 rounded font-bold text-sm tracking-wider">PVC</span>
            {isEditingTitle ? (
              <div className="flex items-center gap-2">
                <input type="text" value={tempTitle} onChange={e=>setTempTitle(e.target.value)} className="text-black px-2 py-1 rounded" autoFocus />
                <button onClick={saveTitle} className="bg-green-500 p-1 rounded hover:bg-green-600"><Save size={16}/></button>
              </div>
            ) : (
              <h1 className="text-xl font-bold flex items-center gap-2 cursor-pointer group" onClick={() => setIsEditingTitle(true)}>
                {systemName} <Edit2 size={14} className="text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity" />
              </h1>
            )}
          </div>
        </div>
        <nav className="container mx-auto px-4 flex gap-1">
          {tabs.map(tab => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-3 text-sm font-bold transition-colors ${activeTab === tab.id ? 'bg-white text-slate-800 rounded-t-lg' : 'hover:bg-slate-700'}`}>
              {tab.label}
            </button>
          ))}
        </nav>
      </header>
      <main className="flex-1 container mx-auto px-4 py-6">{children}</main>
    </div>
  );
}
